import { useQueryClient } from "@tanstack/react-query";

import { bookingConfigKeys } from "./query_keys";

export const useBookingConfigProfileCalendarsInvalidate = () => {
  const queryClient = useQueryClient();

  return {
    invalidate: (calendarId?: string) => {
      if (calendarId) {
        queryClient.invalidateQueries(bookingConfigKeys.profileCalendar(calendarId));
      } else {
        queryClient.invalidateQueries(bookingConfigKeys.profileCalendars());
      }
    }
  };
};
